import React, { Component } from "react";
import { af } from "@gladeye/af";
import { isMobile } from "~/scripts/utils/is-mobile";
import PropTypes from "prop-types";

class ScrollWrapper extends Component {
    static propTypes = {
        posY: PropTypes.number,
        setPosY: PropTypes.func,
        children: PropTypes.node
    };

    stopped = false;
    // posY = 0;

    // state = {
    //     posY: 0
    // };

    constructor(props) {
        super(props);
        this.af = af();
        this.wrapperRef = React.createRef();
        this.body = document.body;
    }

    componentDidMount() {
        if (!isMobile) {
            this.af.addRead(this.read);
            // this.af.addWrite(this.write);
        }
    }

    componentWillUnmount() {
        if (!isMobile) {
            this.af.removeRead(this.read);
            // this.af.removeWrite(this.write);
        }
    }

    read = () => {
        this.prevHeight = this.height;
        this.height = this.wrapperRef.current.clientHeight;
        let { scrollLocked, setPosY, posY } = this.props;
        let { pageYOffset } = window;

        if (scrollLocked) return;

        if (this.prevHeight !== this.height) {
            document.body.style.height = `${this.height}px`;
        }

        if (Math.abs(pageYOffset - posY) < 0.2) {
            if (!this.stopped) {
                setPosY(pageYOffset);
                this.stopped = true;
            }

            return;
        }

        this.stopped = false;
        posY += (pageYOffset - posY) * 0.2;

        setPosY(posY);
    };

    // write = () => {
    //     const { setPosY } = this.props;
    //     let { posY } = this;
    //     // this.setState({ posY });

    // };

    render() {
        const { children, posY } = this.props;

        return (
            <div
                className="scroll-wrapper"
                style={{ transform: `translate3d(0, ${-posY}px, 0)` }}
                ref={this.wrapperRef}
            >
                {children}
            </div>
        );
    }
}

export default ScrollWrapper;



// WEBPACK FOOTER //
// ./src/scripts/components/ScrollWrapper.js